import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";
import SBOMPage from "@/pages/SBOMPage";
import HelpPage from "@/pages/HelpPage";
import ApiPage from "@/pages/ApiPage";
import WhatsBrokenPage from "@/pages/WhatsBrokenPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import SupportPopupHost from "@/components/SupportPopupHost";

function App() {
  useEffect(() => {
    // Strip the Emergent preview badge (CSS can't beat its inline !important).
    const drop = () => {
      const el = document.getElementById("emergent-badge");
      if (el) el.remove();
    };
    drop();
    const observer = new MutationObserver(drop);
    observer.observe(document.body, { childList: true, subtree: false });
    return () => observer.disconnect();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/sbom" element={<SBOMPage />} />
        <Route path="/developers" element={<ApiPage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/whats-broken" element={<WhatsBrokenPage />} />
        <Route path="/whats-broken/:date" element={<WhatsBrokenPage />} />
        <Route path="/cursedgold45/login" element={<AdminLoginPage />} />
        <Route path="/cursedgold45" element={<AdminDashboard />} />
        <Route path="*" element={<Dashboard />} />
      </Routes>
      <PublicChrome />
    </BrowserRouter>
  );
}

function PublicChrome() {
  // Hide popup host on the (obscured) admin route to keep that view clean.
  const { pathname } = useLocation();
  const onAdmin = pathname.startsWith("/cursedgold45");
  if (onAdmin) return null;
  return <SupportPopupHost />;
}

export default App;
